// extracted by mini-css-extract-plugin
export var page404Title = "header-module--page404-title--4toI7";
export var hide = "header-module--hide--1ap-Q";
export var show = "header-module--show--2vZrp";
export var collapse = "header-module--collapse--uZVkk";
export var expand = "header-module--expand--Q3nWP";
export var header = "header-module--header--oZGAE";
export var navigationCanvas = "header-module--navigationCanvas--11lMp";
export var navWrapper = "header-module--navWrapper--2IvZH";
export var mobile_expanded = "header-module--mobile_expanded--1hDgq";
export var mobile_expanded_col1 = "header-module--mobile_expanded_col1--2lFrz";
export var about_expanded = "header-module--about_expanded--2WO0s";
export var image_container = "header-module--image_container--RYaDx";
export var about_expanded_col1 = "header-module--about_expanded_col1--34Lb0";
export var AMXLogo = "header-module--AMXLogo--mhmWT";
export var openCloseIcon = "header-module--openCloseIcon--3qdqO";
export var solutions_expanded = "header-module--solutions_expanded--3y-LR";
export var solutions_expanded_col1 = "header-module--solutions_expanded_col1--2cqdw";
export var insights_expanded = "header-module--insights_expanded--HPcMf";
export var insights_expanded_col1 = "header-module--insights_expanded_col1--2nwme";
export var latest_insights_container = "header-module--latest_insights_container--otqai";
export var latest_insight = "header-module--latest_insight--1PyNk";
export var headerWrap = "header-module--headerWrap--1KMFT";
export var latestInsightsImage = "header-module--latestInsightsImage--UFw4v";
export var active = "header-module--active--1RAVz";